import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./heroslider.css";
import { useSelector } from "react-redux";

const HeroSlider = () => {
  const navigate = useNavigate();

  const [currentSlide, setCurrentSlide] = useState(0);

  // ✅ Redux data (Saga se)
  const { herosliders = [], loading: isLoading = false } = useSelector(
    (state) => state.heroslider || {},
  );

  const STORAGE_URL = process.env.REACT_APP_URL;

  const slides =
    herosliders
      ?.filter((row) => row.is_active)
      ?.sort((a, b) => (a.order ?? 0) - (b.order ?? 0)) || [];

  /* Auto slide (NO CHANGE) */
  useEffect(() => {
    if (!slides.length) return;
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 55000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <section id="home" className="hero">
      {/* STACKED BACKGROUND IMAGES FOR SMOOTH FADE */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`hero-slide${index === currentSlide ? "active" : ""}`}
          style={{
            backgroundImage: `url(${STORAGE_URL + slide.background_image})`,
          }}
        ></div>
      ))}

      <div className="hero-overlay"></div>

      <div className="hero-content home-page animated" key={currentSlide}>
        <h1>
          <React.Fragment>{slides[currentSlide]?.title_lines}</React.Fragment>
        </h1>

        <p className="animated-text">
          {slides[currentSlide]?.description?.split(" ").map((word, index) => (
            <span key={index} style={{ animationDelay: `${index * 0.24}s` }}>
              {word}&nbsp;
            </span>
          ))}
        </p>

        <div className="hero-buttons">
          {slides[currentSlide]?.primary_btn?.text && (
            <button
              className="cta-button"
              onClick={() => navigate(slides[currentSlide]?.primary_btn?.link)}
            >
              {slides[currentSlide]?.primary_btn?.text}
            </button>
          )}
          {slides[currentSlide]?.secondary_btn?.text && (
            <button
              className="secondary-button"
              onClick={() =>
                navigate(slides[currentSlide]?.secondary_btn?.link)
              }
            >
              {slides[currentSlide]?.secondary_btn?.text}
            </button>
          )}
        </div>
      </div>

      {/* Dots */}
      <div className="hero-dots">
        {slides.length > 0 &&
          slides.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentSlide ? "active" : ""}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
      </div>
    </section>
  );
};

export default HeroSlider;
